import { render } from "./RecruitmentBrandManage.vue?vue&type=template&id=29ad8465"
import script from "./RecruitmentBrandManage.vue?vue&type=script&setup=true&lang=js"
export * from "./RecruitmentBrandManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/recruitment/brand/RecruitmentBrandManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29ad8465"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29ad8465', __exports__)) {
    console.log('reload')
    api.reload('29ad8465', __exports__)
  }
  
  module.hot.accept("./RecruitmentBrandManage.vue?vue&type=template&id=29ad8465", () => {
    console.log('re-render')
    api.rerender('29ad8465', render)
  })

}


export default __exports__